import { Box, Card, CircularProgress } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { ActivityItemList } from "./ActivityItemList";
import occupiedUnitsDetailsService from "../../../services/occupiedUnitsDetails.service";

type ActivityListProps = {};

function ActivityListCard({}: ActivityListProps) {
  const { leaseId } = useParams<{ leaseId: string }>();
  if (!leaseId) return null;

  const activityListQuery = useQuery({
    queryKey: ["getActivityListQuery", leaseId],
    queryFn: async () => {
      const response = await occupiedUnitsDetailsService.getActivityListForLease(leaseId);
      return response.data;
    },
  });

  return (
    <Card sx={{ height: "90%", width: "100%" }}>
      {activityListQuery.isLoading ? (
        <Box padding={2.5}>
          <CircularProgress />
        </Box>
      ) : (
        <ActivityItemList activityListQuery={activityListQuery} />
      )}
    </Card>
  );
}

export { ActivityListCard };
